import { Card, CardContent, Typography, Chip, Box, useTheme, alpha } from '@mui/material';
import { motion } from 'framer-motion';

interface ProjectCardProps {
  title: string;
  description: string;
  technologies: {
    frontend: string[];
    backend: string[];
  };
}

const MotionCard = motion(Card);

const ProjectCard = (props: ProjectCardProps) => {
  const { title, description, technologies } = props;

  const theme = useTheme();
  const lighterColor = theme.palette.secondary.lighter || theme.palette.secondary.light;

  return (
    <MotionCard
      elevation={0}
      whileHover={{ y: -6 }}
      transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        p: 3,
        borderRadius: 3,
      }}
    >
      <CardContent sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        p: 0,
        '&:last-child': { pb: 0 }
      }}>
        <Box sx={{ mb: 3 }}>
          <Typography
            variant='h5'
            sx={{
              mb: 1.5,
              fontWeight: 600,
              color: 'text.primary',
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'text.secondary',
              lineHeight: 1.7,
            }}
          >
            {description}
          </Typography>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Box>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              mt: 2,
            }}
          >
            {technologies.frontend.map((tech, index) => (
              <Chip
                key={`frontend-${index}`}
                label={tech}
                size="small"
                sx={{
                  backgroundColor: alpha(theme.palette.secondary.main, 0.1),
                  color: theme.palette.secondary.main,
                  fontWeight: 500,
                  fontSize: '12px',
                  height: '26px',
                  border: `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
                  '&:hover': {
                    backgroundColor: alpha(theme.palette.secondary.main, 0.15),
                  }
                }}
              />
            ))}
            {technologies.backend.map((tech, index) => (
              <Chip
                key={`backend-${index}`}
                label={tech}
                size="small"
                sx={{
                  backgroundColor: alpha(lighterColor, 0.1),
                  color: lighterColor,
                  fontWeight: 500,
                  fontSize: '12px',
                  height: '26px',
                  border: `1px solid ${alpha(lighterColor, 0.2)}`,
                  '&:hover': {
                    backgroundColor: alpha(lighterColor, 0.15),
                  }
                }}
              />
            ))}
          </Box>
        </Box>
      </CardContent>
    </MotionCard>
  );
}

export default ProjectCard;
